import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ProtocolQ, ProtocolStatus } from 'src/app/model/protocol';
import { SnackBarService } from 'src/app/services/snackBar.service';
import { MyErrorStateMatcher } from 'src/app/utils/errorStateMatcher';

export interface DialogDataConfirmSave {
  protocol: ProtocolQ;
  reason: string;
}

@Component({
    selector: 'app-protocol-q-edit-confirm-save',
    templateUrl: './protocol-q-edit-confirm-save.component.html',
    standalone: false,
})
export class ProtocolEditConfirmSaveComponent implements OnInit {

  matcher = new MyErrorStateMatcher();
  form: FormGroup;
  inSignState: boolean;

  constructor(
    fb: FormBuilder,
    private translate: TranslateService,
    public snackBarService: SnackBarService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ProtocolEditConfirmSaveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataConfirmSave) {
    this.form = fb.group({
      reason: [this.data.reason, [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.inSignState = this.data.protocol.idStatus === ProtocolStatus.FIRMADO;
  }

  downloadDocument(): void {

  }

  onOkClick(): void {

    if (!this.form.valid) {
      this.snackBarService.sendError(this.translate.instant('protocolEdit.dialog.confirmSave.form.error.reason') as string);
      return;
    }

    this.dialogRef.close(this.data);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
